/**
 * api_v2/client.ts
 * Безопасный axios-клиент для API v2.
 * — Автоматически добавляет Authorization: Bearer <token> из localStorage
 * — При 401 очищает токен и редиректит на /register
 * — Все секреты хранятся только на сервере, фронт знает только токен сессии
 */

import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { PLATFORM_API_BASE } from "../config/api";

export const API_BASE = PLATFORM_API_BASE;

/** Ключ хранения токена в localStorage — только токен, без данных пользователя */
export const TOKEN_KEY = "simolapps_token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  // Также чистим старый формат на случай совместимости
  localStorage.removeItem("simolapps_state");
  localStorage.removeItem("userId");
  localStorage.removeItem("userName");
  localStorage.removeItem("isRegistered");
  localStorage.removeItem("hasSubscription");
}

const client: AxiosInstance = axios.create({
  baseURL: API_BASE,
  timeout: 15_000,
  headers: { "Content-Type": "application/json" },
});

/** Интерцептор запросов: добавляет токен */
client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getToken();
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  return config;
});

/** Интерцептор ответов: обрабатывает 401 */
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const token = getToken();
      // Не ломаем старый login-flow: если v2-токена нет, просто отдаём 401 вызывающему коду.
      if (token) {
        clearToken();
        if (typeof window !== "undefined") {
          window.location.href = "/register";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default client;
